import { type ReactNode } from 'react'

import { type WindowFrameProps } from '@krp/client-runtime'
import { platformMyResources } from '@krp/platform-ui'
import { ModalFrame } from '@krp/ui-kit'

/** Источники человека с правом читать каталог: те же «мои ресурсы», что и в выборе источника каталога (общий кэш запросов). */
const CATALOG_SOURCES = { capability: 'catalog.read' } as const

/**
 * Рамка окна источника (карточка товара общего каталога, 1С, AQSI, «Собственной»): полоса «Источник · имя» и оттенок окна.
 * Источник и оттенок объявляет пакет окна (`WindowDescriptor.source`), здесь вид ресурса не разбирается; имя ресурса — из
 * «моих ресурсов» по `rid` окна, чтобы при нескольких базах было видно, чья карточка открыта.
 */
export function SourcedModalFrame({
  source,
  resourceId,
  children,
  ...frame
}: Omit<WindowFrameProps, 'source'> & { source: NonNullable<WindowFrameProps['source']>; children: ReactNode; closeActionId: string }) {
  const resources = platformMyResources.useQuery(CATALOG_SOURCES, { skip: resourceId === null })
  const name = resourceId === null ? undefined : resources.data?.find((resource) => resource.id === resourceId)?.displayName
  return (
    <ModalFrame {...frame} source={{ id: source.id, label: source.label, detail: name }}>
      {children}
    </ModalFrame>
  )
}
